import { ApolloClient, ApolloLink, concat, createHttpLink, InMemoryCache } from '@apollo/client/core';
import { useCognitoStore } from '@/stores/cognito';
import { GRAPHQL } from "@/config/graphql";

const httpLink = createHttpLink({
    uri: GRAPHQL.Endpoint
})

const authMiddleware = new ApolloLink((operation, forward) => {
    // add the authorization to the headers
    // Get the Cognito idToken if available for GraphQL header
    const storeCognito = useCognitoStore();
    const idToken = storeCognito.getIdToken;

    operation.setContext({
        headers: {
            authorization: idToken ? `Bearer ${idToken}` : "",
        },
    });
    return forward(operation);
});
export const apolloClient = new ApolloClient({
    link: concat(authMiddleware, httpLink),
    cache: new InMemoryCache(),
});
